import moment from 'moment'
import { array } from 'prop-types'
import { AnalyticsLayer } from '@opallabs/quanta'
import { getSelectedValues } from '../ContentFilter/helpers'
import ExportToCSV from '../ExportToCSV'
import { buildStoryFilters } from '../FilterBar/FilterBuilders/storyFilter'

const sanitizeFilterTree = (filterTree) =>
  filterTree.filter((filter) => filter.title !== 'Live Date Range')

const filterTree = (props) => {
  if (!props.filterProps || !props.filterProps.filterTree) {
    return null
  }

  const preppedFilters = sanitizeFilterTree(props.filterProps.filterTree)
  const labelFilter = preppedFilters.find((ft) => ft.title === 'Labels')

  if (labelFilter) {
    // Create a new object instead of mutating the immutable original
    const labelFilterCopy = { ...labelFilter, groupOrAble: false }
    const labelFilterIndex = preppedFilters.indexOf(labelFilter)
    preppedFilters[labelFilterIndex] = labelFilterCopy
  }

  return preppedFilters
}

const defaultFilename = () => `Opal_Story_Export_${moment().format('MMDDYYYY')}`

export const filterSieve = (enabledFilters) => {
  const filters = {
    labelIds: [],
  }

  enabledFilters.forEach((filter) => {
    switch (filter.payload.type_key) {
      case 'labels':
        filters.labelIds.push(filter.payload.object.id)
        break
      default:
        break
    }
  })

  return filters
}

export const csvParams = (opts) => {
  const preCsvParams = {
    brand_id: opts.workspaceId,
    data_type: 'story',
    scheduled_start_at: opts.startDate,
    scheduled_end_at: opts.endDate,
    label_ids: opts.labelIds,
    filename: opts.filename,
  }
  return preCsvParams
}

const StoryExport = (props) => {
  const storyFilterTree = buildStoryFilters({ stories: props.stories || [] })

  return (
    <AnalyticsLayer name="Story Export">
      <ExportToCSV
        {...props}
        withSearch={false}
        withDateRange={true}
        title="Export CSV &bull; Stories"
        filenamePlaceholder="E.g. Yearly Story Data"
        filterTree={filterTree(props, storyFilterTree)}
        value={getSelectedValues(props, storyFilterTree)}
        csvParams={csvParams}
        filterSieve={filterSieve}
        defaultFilename={defaultFilename()}
      />
    </AnalyticsLayer>
  )
}

StoryExport.propTypes = {
  stories: array,
}

export default StoryExport
